import Helpers from '../helpers/Helpers'

class QuestionnaireRedirect {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(this._elem.innerHTML)
    }

    onInit () {
        document.addEventListener('esc--questionnaire-completed', e => {
            if (this._data.customer) {
                window.location = e.detail
            } else {
                localStorage.setItem('completed-questionnaire', true)
                window.location = '/account/register'
            }
        })
        if (this._data.customer && localStorage.getItem('completed-questionnaire')) {
            localStorage.removeItem('completed-questionnaire')
            window.location = Helpers.getRechargeURL(this._data.customer.id, this._data.customer.email)
        }
    }
}

export default QuestionnaireRedirect



// WEBPACK FOOTER //
// ./resources/scripts/components/QuestionnaireRedirect.js